import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9dce7378")

_pushScopeId("data-v-9dce7378")
const _hoisted_1 = {
  key: 0,
  class: "home"
}
const _hoisted_2 = {
  key: 1,
  class: "con"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", null, " You are not set up as an employee in GoTime, so you cannot request time off. You can approve time for your direct reports using GoTime. ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NewRequestButton = _resolveComponent("NewRequestButton")!
  const _component_leave_list = _resolveComponent("leave-list")!

  return (_ctx.userInfoData && _ctx.userInfoData.isEmployee)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_NewRequestButton, { link: "/new-request" }),
        _createVNode(_component_leave_list, {
          title: 'Active',
          userLeaveList: _ctx.userLeaveRequestsData,
          processType: _ctx.processType,
          formatDate: _ctx.formatDate,
          withdrawRequest: _ctx.withdrawRequest,
          deleteDeclined: _ctx.deleteDeclined,
          key: _ctx.leaveRequestKey,
          userInfoData: _ctx.userInfoData
        }, null, 8, ["userLeaveList", "processType", "formatDate", "withdrawRequest", "deleteDeclined", "userInfoData"]),
        _createVNode(_component_leave_list, {
          title: 'History',
          userLeaveList: _ctx.userLeaveHistoryData,
          processType: _ctx.processType,
          formatDate: _ctx.formatDate,
          withdrawRequest: _ctx.withdrawRequest,
          deleteDeclined: _ctx.deleteDeclined,
          key: _ctx.leaveHistoryKey,
          userInfoData: _ctx.userInfoData
        }, null, 8, ["userLeaveList", "processType", "formatDate", "withdrawRequest", "deleteDeclined", "userInfoData"])
      ]))
    : (_ctx.userInfoData && !_ctx.userInfoData.isEmployee)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true)
})